<template>
<v-card id="AccountDetails">
  <v-card-text>
    <v-container grid-list-md>
      <v-layout row wrap class="text-xs-left">
        <v-flex xs12 md6>
          <v-subheader>
            {{ $vuetify.t('$vuetify.account.contactInfo') }}
          </v-subheader>
          <v-layout row wrap class="accountDetailsText">
            <v-flex xs4 md3>{{ $vuetify.t('$vuetify.common.firstName') }}:</v-flex>
            <v-flex xs8 md9>{{ customer.firstName }}</v-flex>
            <v-flex xs4 md3>{{ $vuetify.t('$vuetify.common.lastName') }}:</v-flex>
            <v-flex xs8 md9>{{ customer.lastName }}</v-flex>
            <v-flex xs4 md3>{{ $vuetify.t('$vuetify.common.phone') }}:</v-flex>
            <v-flex xs8 md9>{{ customer.telephone | phone }}</v-flex>
            <v-flex xs4 md3>{{ $vuetify.t('$vuetify.common.email') }}:</v-flex>
            <v-flex xs8 md9>{{ customer.email }}</v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6>
          <v-subheader>{{ $vuetify.t('$vuetify.account.membershipInfo') }}
          </v-subheader>
          <v-layout row wrap class="accountDetailsText">
            <v-flex xs4 md3>{{ $vuetify.t('$vuetify.common.status') }}:</v-flex>
            <v-flex xs8 md9>
              {{ rewards.isMember ? $vuetify.t('$vuetify.account.member') : $vuetify.t('$vuetify.account.nonMember') }}
            </v-flex>
            <v-flex xs4 md3>{{ $vuetify.t('$vuetify.common.points') }}:</v-flex>
            <v-flex xs8 md9>{{ rewards.points | comma }}</v-flex>

            <!-- <template v-if="getStore.features.membershipSupported && getStore.features.membershipDepositSupported"> -->
              <v-flex xs4 md3>{{ membershipTitle }}:</v-flex>
              <v-flex xs8 md9>{{ $currency(rewards.balance, true, true) }}</v-flex>
            <!-- </template> -->
          </v-layout>
        </v-flex>

        <div v-if="rewardOptions && rewardOptions.length" class="Rewards">
          <v-subheader :class="{'sticky': $vuetify.breakpoint.smAndDown }">
            {{ $vuetify.t('$vuetify.account.rewards.rewardOptions') }} ({{ rewards.points | comma }})
          </v-subheader>

          <div class="CardContainer" :class="{ 'sideScroll': $vuetify.breakpoint.name !== 'xs' }">
            <template v-for="rewardOption in rewardOptions">
              <reward-options-card
                :key="rewardOption.id"
                :reward-option="rewardOption"
              />
            </template>
          </div>
        </div>

        <div v-if="getPunchCards && getPunchCards.length" class="Rewards">
          <v-subheader :class="{'sticky': $vuetify.breakpoint.smAndDown }">
            {{ $vuetify.t('$vuetify.account.rewards.punchCards') }}
          </v-subheader>

          <div class="CardContainer" :class="{ 'sideScroll': $vuetify.breakpoint.name !== 'xs' }">
            <template v-for="punchCard in getPunchCards">
              <punch-card
                :key="punchCard.id"
                :punchCard="punchCard"
                information
              />
            </template>
          </div>
        </div>

        <div v-if="coupons && coupons.length" class="Rewards">
          <v-subheader :class="{'sticky': $vuetify.breakpoint.smAndDown }">
            {{ $vuetify.t('$vuetify.account.rewards.coupons') }}
          </v-subheader>

          <div class="CardContainer" :class="{ 'sideScroll': $vuetify.breakpoint.name !== 'xs' }">
            <template v-for="(coupon, index) in coupons">
              <coupon-card v-if="isEligible(coupon)"
                :key="`menu_${index}${coupon.code}`"
                :coupon="coupon"
                allowConfig
              />
            </template>
          </div>
        </div>
      </v-layout>

      <v-btn color="primary" outline @click="editDetails = true" id="editDetails">
        {{ $vuetify.t('$vuetify.common.edit') }}
      </v-btn>

      <v-dialog
        v-model="editDetails"
        persistent
        :max-width="$vuetify.breakpoint.smAndDown ? '' : 675"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        transition="slide-y-reverse-transition"
        class="menu-item-config"
        content-class="menu-config-dialog"
      >
        <account-details-config />
      </v-dialog>
    </v-container>
  </v-card-text>
</v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import get from 'lodash/get';


  import { matchTranslation } from "@/services/util.service"


  import PunchCard from "../Common/PunchCard"
  import CouponBuilder from "../Coupons/CouponBuilder"
  import CouponCard from '../Coupons/CouponCard'
  import RewardOptionsCard from "../RewardsOptions/RewardOptionsCard"
  import AccountDetailsConfig from "./AccountDetailsConfig.vue"

  export default {
    components: {
      PunchCard,
      CouponBuilder,
      CouponCard,
      RewardOptionsCard,
      AccountDetailsConfig
    },

    data: () => ({
      editDetails: false
    }),

    computed: {
      allowGiftCard() {
        return get(this.getStore, 'features.selfcareGiftcardSupported', false) ||
                get(this.getStore, 'features.selfcareMembershipDepositSupported', false)
      },
      buildGiftCardUrl() {
        return `${process.env.VUE_APP_APP_BASE}/giftcard/${3000}?name=${this.customer.firstName} ${this.customer.lastName}&telephone=${this.customer.telephone}&email=${this.customer.email}`
      },

      customer() {
        return this.getCustomer || {}
      },
      rewards() {
        return this.getCustomerRewards || {}
      },
      coupons() {
        return get(this.getCustomerRewards, 'coupons', [])
      },
      rewardOptions() {
        return get(this.getRewards, 'redeemOptions', [])
      },

      membershipTitle() {
        const _customName = get(this.getStore, 'settings.membershipSettings.customMembershipName')

        if (!!_customName) {
          const _translation = matchTranslation(_customName.translations)

          if (!!_translation)
            return _translation;
        }

        return this.$vuetify.t('$vuetify.common.balance')
      },

      ...mapGetters([ 'getStore', 'getCustomer', 'getCustomerRewards', 'getPunchCards', 'getRewards' ])
    },

    methods: {
      isEligible(coupon) {
        if (!(coupon && 'eligibilityResult' in coupon))
          return false

        return (coupon.eligibilityResult.isEligible || coupon.eligibilityResult.shouldShowIfNotEligible) || (!!coupon.charges && !coupon.uuid)
      },

      ...mapActions([ 'fetchAccountDetails', 'fetchOptions' ])
    },

    created() {
      this.fetchAccountDetails(this.$route.params.sid)
      this.fetchOptions()
    }
  }
</script>

<style>
  #AccountDetails {
    /* border: var(--card-border) !important;
    border-radius: var(--card-border-radius); */
    box-shadow: none !important;
  }
  #AccountDetails .v-subheader {
    font-size: var(--text-size-2) !important;
    padding: 0px !important;
    margin-top: 20px;
  }
  .accountDetailsText {
    font-size: var(--text-size-1) !important;
  }

  .Rewards {
    width: 100%;
    margin-top: 20px;
  }

  .CardContainer {
    position: relative;
  }
  .CardContainer,  {
    z-index: 999;
  }
  .sideScroll {
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
  }

  .CardContainer.sideScroll>div {
    margin: 0px 5px !important;
  }

  .v-subheader.sticky {
    /* position: -webkit-sticky;
    position: sticky;
    top: 10px;
    z-index: 0;
    background-color: white; */
  }

  #editDetails {
    position: absolute;
    top: 10px;
    right: 10px;
  }
</style>
<style scoped>
  .CardContainer {
    flex: unset;
  }
  .v-subheader {
    text-align: left;
  }
</style>